import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MeineAufgabenStore } from './meine-aufgaben.store';
import { AufgabenListeComponent } from './aufgaben-liste/aufgaben-liste.component';

interface SatzTeil {
  text: string;
  uebersetzen?: boolean;
  params?: Record<string, number>;
  stark?: boolean;
  rot?: boolean;
}

@Component({
  selector: 'app-meine-aufgaben-card',
  imports: [RouterLink, MatIcon, TranslatePipe, AufgabenListeComponent],
  templateUrl: './meine-aufgaben-card.component.html',
  styleUrl: './meine-aufgaben-card.component.scss',
  providers: [MeineAufgabenStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeineAufgabenCardComponent implements OnInit {
  protected readonly store = inject(MeineAufgabenStore);

  // Als Teile statt im Template, sonst setzt Angular vor Komma und Punkt ein Leerzeichen.
  protected readonly satz = computed<SatzTeil[]>(() => {
    const offen = this.store.offene().length;
    const ueberfaellig = this.store.ueberfaellig();
    const heute = this.store.heute();
    const teile: SatzTeil[] = [
      { text: 'home.aufgaben.satz.anfang', uebersetzen: true },
      { text: ' ' },
      {
        text: offen === 1 ? 'home.aufgaben.satz.offen.eins' : 'home.aufgaben.satz.offen.viele',
        params: { n: offen },
        stark: true,
      },
    ];
    if (ueberfaellig > 0) {
      teile.push(
        { text: ' — ' },
        { text: 'home.aufgaben.satz.ueberfaellig', params: { n: ueberfaellig }, stark: true, rot: true },
      );
    }
    if (heute > 0) {
      teile.push(
        { text: ueberfaellig > 0 ? ', ' : ' — ' },
        { text: 'home.aufgaben.satz.heute', params: { n: heute }, stark: true },
      );
    }
    teile.push({ text: '.' });
    return teile;
  });

  ngOnInit(): void {
    this.store.laden();
  }
}
